import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';

interface SessionTimeoutWarningProps {
  open: boolean;
  remainingSeconds: number;
  onStayLoggedIn: () => void;
  onLogout: () => void;
}

export function SessionTimeoutWarning({
  open,
  remainingSeconds,
  onStayLoggedIn,
  onLogout,
}: SessionTimeoutWarningProps) {
  const minutes = Math.floor(remainingSeconds / 60);
  const seconds = remainingSeconds % 60;
  const timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`;

  return (
    <Dialog
      open={open}
      data-session-warning
      disableEscapeKeyDown
      aria-labelledby="session-timeout-title"
    >
      <DialogTitle id="session-timeout-title" sx={{ fontSize: '1.5rem' }}>
        Session Expiring Soon
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          Your session is about to expire due to inactivity.
        </Typography>
        <Box display="flex" justifyContent="center" py={2}>
          <Typography variant="h4" color="error" fontWeight="bold">
            {timeDisplay}
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Click &quot;Stay Logged In&quot; to continue your session, or you will
          be logged out automatically.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onLogout} color="inherit">
          Log Out
        </Button>
        <Button onClick={onStayLoggedIn} variant="contained" autoFocus>
          Stay Logged In
        </Button>
      </DialogActions>
    </Dialog>
  );
}
